/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  obdobiLabel: {
    id: "b2b.rezervace-vytvoreni.obdobi.label",
    defaultMessage: "Period"
  },
  datumOdLabel: {
    id: "b2b.rezervace-vytvoreni.datumOd.label",
    defaultMessage: "Date"
  },
  doplnkoveSluzbyLabel: {
    id: "b2b.rezervace-vytvoreni.doplnkove-sluzby.label",
    defaultMessage: "Additional Services"
  },
  poznamkaLabel: {
    id: "b2b.rezervace-vytvoreni.poznamka.label",
    defaultMessage: "Note"
  },
  fixniNarokyLabel: {
    id: "b2b.rezervace-vytvoreni.fixni-naroky.label",
    defaultMessage: "Fixed requirements for selected period and resource"
  },
  fixniNarokyText: {
    id: "b2b.rezervace-vytvoreni.fixni-naroky.text",
    defaultMessage: "Entered: {zadane} | Allowed: {povolene}"
  },
  saveDialogTitle: {
    id: "b2b.rezervace-vytvoreni.save-dialog.title",
    defaultMessage: "Submit Request"
  },
  buttonSubmit: {
    id: "b2b.rezervace-vytvoreni.submit",
    defaultMessage: "Send reservation"
  },
  rychlaWidgetTitle: {
    id: "b2b.rezervace-vytvoreni.rychla-widget.title",
    defaultMessage: "Quick Reservation Request"
  },
  rychlaWidgetSubmint: {
    id: "b2b.rezervace-vytvoreni.rychla-widget.submit",
    defaultMessage: "Create Reservation"
  }
});

export default () => useMessages(MESSAGES);
